import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import SearchOffIcon from '@mui/icons-material/SearchOff'

interface EmptyStateProps {
  heading?: string
  body?: string
  action?: { label: string; onClick: () => void }
}

export default function EmptyState({
  heading = 'No results found',
  body = 'Try adjusting your search or filter criteria.',
  action,
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 8,
        px: 3,
        border: '1px dashed',
        borderColor: 'rgba(184, 115, 51, 0.35)',
        borderRadius: 3,
        backgroundColor: 'rgba(184, 115, 51, 0.04)',
      }}
    >
      <SearchOffIcon sx={{ fontSize: 48, color: '#B87333', mb: 2, opacity: 0.8 }} />
      <Typography variant="h6" sx={{ mb: 1, color: 'text.secondary' }}>
        {heading}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: action ? 3 : 0 }}>
        {body}
      </Typography>
      {action && (
        <Button variant="outlined" color="primary" size="small" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </Box>
  )
}
